export default __webpack_public_path__ + "static/dashboard.ja-3681a9b8941b3f3242b03f46b2d3b17e.svg";